export default __webpack_public_path__ + "static/media/img03.041657a5.jpg";